import React, { useEffect, useState, createContext, useContext } from "react";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Home from "../pages/admin/home";
import ViewReport from "../pages/admin/viewreport";
import UserList from "../pages/admin/userList";
import CreateReport from "../pages/admin/createReport";
import Assignreport from "../pages/admin/assignreport";
import AdminLogin from "../pages/admin/adminLogin";
import Register from "../pages/admin/Register";
import SecurityWatch from "../pages/admin/securityWatch";
import ClientList from "../pages/admin/clientList";
import ClientHours from "../pages/admin/clientHours";
import Invoicing from "../pages/admin/invoicing";
import ReportCustomize from "../pages/admin/reportCustomize";
import CostumizeAssignreport from "../pages/admin/costumizeAssignreport";
import AssignPermission from "../pages/admin/assignPermission";
import Geolocationsetup from "../pages/admin/geolocationsetup";
import Timeclocksetup from "../pages/admin/timeclocksetup";
import Setupnewclient from "../pages/admin/setupnewclient";
import Modifyclient from "../pages/admin/modifyclient";
import Generateinvoice from "../pages/admin/generateinvoice";
import Viewopeninvoices from "../pages/admin/viewopeninvoices";
import Viewpaidinvoices from "../pages/admin/viewpaidinvoices";
import Invoicestatement from "../pages/admin/invoicestatement";
import DeleteInvoice from "../pages/admin/deleteInvoice";
import Managementlist from "../pages/admin/managementlist";
import SecurityList from "../pages/admin/securityList";
import UserListclient from "../pages/admin/userList.client";
import ProtectedRoute from "../config/protectedRoute";
import { auth } from "../config/config";
import Layout from "../components/layout";
import { useAppContext } from "../context/appContext";
import DummyPage from "../components/dummyPage";
import AdminRegister from "../pages/admin/Register";
import UserPermission from "../config/userPermission";
import UserListAdmin from "../pages/admin/userList.admin.js";
import Protection from "./protection.js";
// import Administrator from "../pages/admin/administrator.js";
import VerifyUser from "../pages/admin/verifyUser.js";
import ResetPassword from "../pages/admin/resetPassword.js";
import ChoiseRegisterForUser from "../pages/admin/choiseRegisterForUser.js";
import { TOKEN_KEY } from "../config/variable.js";
import ViewTour from "../pages/admin/viewTour.js";
import CreateTour from "../pages/admin/createTour.js";
import EditTour from "../pages/admin/EditTour.js";

// Create a context to manage unsaved changes
const UnsavedChangesContext = createContext();


const savedLocalStorage = JSON.parse(localStorage.getItem(TOKEN_KEY));
const savedSessionStorage = JSON.parse(sessionStorage.getItem(TOKEN_KEY));
export const User = savedLocalStorage || savedSessionStorage;


export const useUnsavedChanges = () => {
  return useContext(UnsavedChangesContext);
};

const Routers = () => {
  const { UserType, isAuthUser, setIsAuthUser } = useAppContext();
  const [isChangesInCreateReport, setIsChangesInCreateReport] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   document.title = "Admin Portal - Maximal Security";
  //   const unsubscribe = auth.onAuthStateChanged((user) => {
  //     if (user) {
  //       setIsAuthUser(user);
  //       console.log("user is verified",user)
  //       navigate("/home")
  //     } else {
  //       console.log("user is not verified",user)
  //       setIsAuthUser(null);
  //       navigate("/")
  //     }
  //   });

  //   return () => unsubscribe();
  // }, []);
  const location = useLocation();


  const isPathNameForPasswordVerification =
    location.pathname.includes("/verifyuser");
  console.log(
    "isPathNameForPasswordVerification",
    isPathNameForPasswordVerification
  );

  const auth = isPathNameForPasswordVerification ? false : User ? true : false;

  const [isAuthenticated, setIsAuthenticated] = useState(auth);
  // useEffect(() => {
  //   alert(isAuthenticated);
  // }, [isAuthenticated]);
  const RedirectToExternal = () => {
    useEffect(() => {
      window.location.replace("https://login.maximalsecurityservices.com/");
      localStorage.removeItem("maxUser");
    }, []);

    return null;
  };
  return (
    <UnsavedChangesContext.Provider
      value={{ isChangesInCreateReport, setIsChangesInCreateReport }}
    >
      <Layout>
        <Routes>
          {/* Public routes */}
          {/* <Route path='/' element={<DummyPage />} /> */}
          {/* management login */}
          {!isAuthenticated ? (
            <>
              <Route path="/" element={<AdminLogin />} />
              <Route path="/login" element={<AdminLogin />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
              <Route path="/register" element={<AdminRegister />} />
              <Route path="/role" element={<ChoiseRegisterForUser />} />
              <Route path="/verifyuser/:userId" element={<VerifyUser />} />
              <Route path="*" element={<Navigate to={"/login"} />} />
            </>
          ) : (
            // <Route
            //   path="*"
            //   element={
            // <ProtectedRoute>
            <>
              {/* Admin routes */}
              <Route path="/" element={<Navigate to="/createReport" />} />
              <Route path="/home" element={<Home />} />
              <Route path="/viewreport" element={<ViewReport />} />
              <Route
                path="/viewreport/:reportTempId"
                element={<ReportCustomize />}
              />
              <Route path="/createreport" element={<CreateReport />} />
              <Route
                path="/createreport/:reportTempId"
                element={<CreateReport />}
              />
              <Route path="/assignreport" element={<Assignreport />} />
              <Route
                path="/assignreport/:assignreportId"
                element={<CostumizeAssignreport />}
              />

              {/* Tours */}

              <Route path="/viewtour" element={<ViewTour />} />
              <Route path="/createtour" element={<CreateTour />} />
              <Route path="/viewtour/:tourId" element={<EditTour />} />

              <Route path="/securitywatch" element={<SecurityWatch />} />
              <Route path="/clientlist" element={<ClientList />} />
              <Route path="/clienthours" element={<ClientHours />} />
              <Route path="/adminlist" element={<UserListAdmin />} />
              <Route path="/invoicing" element={<Invoicing />} />
              <Route path="/assignpermissions" element={<AssignPermission />} />
              <Route path="/geolocationsetup" element={<Geolocationsetup />} />
              <Route path="/timeclocksetup" element={<Timeclocksetup />} />
              <Route path="/setupnewclient" element={<Setupnewclient />} />
              <Route
                path="/modifyclient"
                element={
                  <UserPermission role="Admin" element={<Modifyclient />} />
                }
              />
              <Route path="/generateinvoice" element={<Generateinvoice />} />
              <Route path="/viewopeninvoices" element={<Viewopeninvoices />} />
              <Route path="/viewpaidinvoices" element={<Viewpaidinvoices />} />
              <Route path="/invoicestatement" element={<Invoicestatement />} />
              <Route path="/deleteInvoice" element={<DeleteInvoice />} />
              <Route path="/userclient" element={<UserListclient />} />
              <Route path="/security" element={<SecurityList />} />
              <Route path="/managements" element={<Managementlist />} />
              {/* <Route path="/administrator" element={<Administrator />} /> */}
            </>
            // </ProtectedRoute>
            // }
            // />
          )}
        </Routes>
      </Layout>
    </UnsavedChangesContext.Provider>
  );
};

export default Routers;
